// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import Backbone from 'backbone';
import $ from 'jquery';

import ifCreateFromHash from 'util/ifCreateFromHash';
import runModal from 'ui-library/runModal';
import CreateSourceModal from 'create-components/CreateSourceModal';

class CreateSourceHashView extends Backbone.View {
  render() {
    function openModal() {
      runModal(CreateSourceModal, {});
    }

    $(document).on('click', '.js-create-new-project', (e) => {
      e.preventDefault();
      openModal();
    });

    ifCreateFromHash('#create/project', openModal);
    return this;
  }
}

export default CreateSourceHashView;
